var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWidgetList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.725,
    height: 14.335,
    viewBox: "0 0 16.725 14.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.618 5.973H6.69c-.659 0-.717.534-.717 1.195s.057 1.195.717 1.195h6.929c.659 0 .717-.534.717-1.195s-.058-1.195-.718-1.195zm2.389 5.973H6.69c-.659 0-.717.534-.717 1.195s.057 1.195.717 1.195h9.318c.659 0 .717-.534.717-1.195s-.058-1.195-.717-1.195zM6.69 2.389h9.318c.659 0 .717-.534.717-1.195S16.667 0 16.008 0H6.69c-.659 0-.717.534-.717 1.195s.057 1.194.717 1.194zM2.867 5.973H.717C.058 5.973 0 6.507 0 7.168s.057 1.195.717 1.195h2.15c.659 0 .717-.534.717-1.195s-.058-1.195-.717-1.195zm0 5.973H.717c-.659 0-.717.534-.717 1.195s.057 1.195.717 1.195h2.15c.659 0 .717-.534.717-1.195s-.058-1.195-.717-1.195zM2.867 0H.717C.058 0 0 .534 0 1.195S.057 2.39.717 2.39h2.15c.659 0 .717-.534.717-1.195S3.526 0 2.867 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetList);
export default __webpack_public_path__ + "static/media/widget-list.a93d06e2.svg";
export { ForwardRef as ReactComponent };